import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hcon-table-headers',
  template: '<ng-content select="hcon-table-header"></ng-content>',
  styleUrls: ['./table-headers.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeadersComponent {}
